import { useEffect, useState, ReactNode } from 'react';
import { fetchTopics } from '@api/fetch-topics';
import { IMessage, INlpResponse, ITopic } from '@common/types';
import { CURRENT_INSTANCE } from '@lib/utils';
import ChatProviderContext from '@stores/contexts/chat-context';

interface IChatProviderProps {
  children: ReactNode;
}

function ChatProvider({ children, ...props }: IChatProviderProps) {
  const [topics, setTopics] = useState<ITopic[]>([]);
  const [selectedTopic, setSelectedTopic] = useState<string>('');
  const [messages, setMessages] = useState<IMessage[]>([]);
  const [responses, setResponses] = useState<Array<{ id: number; response: INlpResponse }>>([]);

  useEffect(() => {
    if (topics.length === 0) {
      fetchTopics()
        .then((result) => {
          if (result) {
            if (CURRENT_INSTANCE.topics.length === 0) {
              setTopics(result);
            } else {
              setTopics(
                result.filter((topic) => CURRENT_INSTANCE.topics.includes(topic.name.toLowerCase()))
              );
            }
          }
        })
        .catch(console.error);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const value = {
    topics,
    selectedTopic,
    setSelectedTopic,
    messages,
    addMessage: (message: IMessage) => setMessages((prev) => [...prev, message]),
    responses,
    addResponse: (id: number, response: INlpResponse) =>
      setResponses((prev) => [...prev, { id, response }]),
  };

  return (
    <ChatProviderContext.Provider {...props} value={value}>
      {children}
    </ChatProviderContext.Provider>
  );
}

export default ChatProvider;
